import React from 'react';

function SuggestedSwaps({ swapExercises = [] }) {
    return (
        <div className="swap-exercises-list-container">
            <label className="swap-exercises-label">Suggested Swaps</label>
            {swapExercises.length > 0 ? (
                <span style={{ fontSize: '12px' }}>
                    {swapExercises.map(s => s.title).join(', ')}
                </span>
            ) : (
                <p className="swap-exercises-empty">Add swaps in the library</p>
            )}
        </div>
    );
}

export default SuggestedSwaps;



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/SuggestedSwaps.jsx